// Vragen en antwoorden als tabs: één vraag tegelijk, met pijltjestoetsen. Zonder JS staan alle antwoorden onder elkaar.
document.querySelectorAll("[data-faq-tabs]").forEach((layout) => {
	const tabs = [...layout.querySelectorAll(".faq-tab")];
	const panels = [...layout.querySelectorAll(".faq-answer")];

	if (!tabs.length || tabs.length !== panels.length) return;

	const wrapper = layout.querySelector(".faq-wrapper");
	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

	// Een langer of korter antwoord laat het blok mee groeien of krimpen in plaats van te springen: de hoogte gaat van de oude naar de nieuwe waarde.
	const animateHeight = (from, to) => {
		if (reduceMotion.matches || from === to) return;

		wrapper.style.height = `${from}px`;
		wrapper.style.overflow = "hidden";
		wrapper.getBoundingClientRect();
		wrapper.style.transition = "height 0.35s ease-in-out";
		wrapper.style.height = `${to}px`;

		wrapper.addEventListener(
			"transitionend",
			() => {
				wrapper.style.height = wrapper.style.overflow = wrapper.style.transition = "";
			},
			{ once: true },
		);
	};

	const select = (index, focus = false) => {
		const from = wrapper.offsetHeight;

		tabs.forEach((tab, tabIndex) => {
			const isActive = tabIndex === index;
			tab.classList.toggle("is-active", isActive);
			tab.setAttribute("aria-selected", isActive ? "true" : "false");
			tab.tabIndex = isActive ? 0 : -1;
			panels[tabIndex].hidden = !isActive;
		});

		// De eerste keuze (bij het laden) en een herhaalde klik animeren niet; daarna fadet het nieuwe antwoord in via .is-switching.
		if (layout.classList.contains("is-switching")) animateHeight(from, wrapper.offsetHeight);

		if (focus) tabs[index].focus();
	};

	tabs.forEach((tab, index) => {
		tab.addEventListener("click", () => select(index));

		tab.addEventListener("keydown", (event) => {
			const last = tabs.length - 1;
			const targets = {
				ArrowDown: index === last ? 0 : index + 1,
				ArrowUp: index === 0 ? last : index - 1,
				Home: 0,
				End: last,
			};

			if (!(event.key in targets)) return;

			event.preventDefault();
			select(targets[event.key], true);
		});
	});

	select(0);
	layout.classList.add("is-switching");
});
